import CheckIcon from "@mui/icons-material/Check";
import { Button, Dialog, FormControl, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { VendorTicketDetail } from "../../../../@types/DRO/WarrantyTicketsResponse";
import { WarrantyTicketsApi } from "../../../../api/WarrantyTickets/WarrantyTicketsApi";
import { useLoading } from "../../../../views/Loader/LoadingContext";

interface ReplaceDialogProps {
  open: boolean;
  row: VendorTicketDetail | null;
  onClose: () => void;
  onSuccess: () => void;
}

const ReplaceDialog: React.FC<ReplaceDialogProps> = ({ open, row, onClose, onSuccess }) => {
  const { setLoading } = useLoading();
  const [newUid, setNewUid] = useState("");
  const [successOpen, setSuccessOpen] = useState(false);
  const [hubs, setHubs] = useState<{ hubId: number; hubName: string }[]>([]);
  const [selectedHubId, setSelectedHubId] = useState<string>("");

  useEffect(() => {
    if (open) {
      setSelectedHubId("");
      WarrantyTicketsApi.api.getHubList().then(setHubs).catch(console.error);
    }
  }, [open]);

  const handleClose = () => {
    setNewUid("");
    setSelectedHubId("");
    onClose();
  };

  const handleConfirm = async () => {
    if (!row) return;
    handleClose();
    setLoading(true);
    try {
      await WarrantyTicketsApi.api.warrantyTicketAction({
        warrantyActionItems: [{ uid: row.uid, action: "REPLACE", imageId: row.imageId, remarks: "", newUid, hubId: Number(selectedHubId) }],
      });
      setSuccessOpen(true);
      onSuccess();
    } catch (error) {
      console.error("Error replacing ticket", error);
    }
    setLoading(false);
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{ sx: { borderRadius: 3, p: 3, width: 380 } }}>
        {/* <p className="text-base font-semibold text-gray-800 mb-1">UID Replace</p> */}
        <p className="text-sm font-semibold text-gray-600 mb-4">
          You're Replacing The UID, Please Enter The New UID
        </p>
        <TextField
          fullWidth
          size="small"
          placeholder="Enter New UID"
          value={newUid}
          onChange={(e) => setNewUid(e.target.value)}
          sx={{ mb: 3, bgcolor: "white" }}
        />
        <FormControl fullWidth size="small" sx={{ mb: 4 }}>
          <InputLabel>Select Hub</InputLabel>
          <Select
            label="Select Hub"
            value={selectedHubId}
            onChange={(e: SelectChangeEvent) => setSelectedHubId(e.target.value)}>
            {hubs.map((h) => (
              <MenuItem key={h.hubId} value={String(h.hubId)}>{h.hubName}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div className="flex items-center justify-end gap-3">
          <Button
            variant="outlined"
            size="small"
            onClick={handleClose}
            sx={{ textTransform: "none", borderRadius: 5, borderColor: "#ccc", color: "#333", "&:hover": { borderColor: "#999" } }}>
            No, Go Back
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={!newUid.trim() || !selectedHubId}
            onClick={handleConfirm}
            sx={{
              textTransform: "none",
              borderRadius: 5,
              bgcolor: newUid.trim() && selectedHubId ? "#2563EB" : undefined,
              "&:hover": { bgcolor: newUid.trim() && selectedHubId ? "#1D4ED8" : undefined },
            }}>
            Mark Replaced
          </Button>
        </div>
      </Dialog>

      <Dialog
        open={successOpen}
        onClose={() => setSuccessOpen(false)}
        PaperProps={{ sx: { borderRadius: 3, p: 4, width: 280 } }}>
        <div className="flex flex-col items-center gap-4">
          <div className="w-16 h-16 rounded-full bg-blue-600 flex items-center justify-center">
            <CheckIcon sx={{ color: "white", fontSize: 36 }} />
          </div>
          <p className="text-gray-800 font-semibold text-center">Part Marked Replaced!</p>
        </div>
      </Dialog>
    </>
  );
};

export default ReplaceDialog;
